/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Trust_Window_Scope_SpaceInputs */



/**
* | output |
* | --- |
* | "this space" |
*
* @param {Chat_Tool_Trust_Window_Scope_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_scope_space = /** @type {((inputs?: Chat_Tool_Trust_Window_Scope_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_Scope_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("diesen Space")
	return /** @type {LocalizedString} */ ("this space")
});